import { render, staticRenderFns } from "./learningdevelopment.vue?vue&type=template&id=0e0bcfcb&scoped=true&"
import script from "./learningdevelopment.vue?vue&type=script&lang=js&"
export * from "./learningdevelopment.vue?vue&type=script&lang=js&"
import style0 from "./learningdevelopment.vue?vue&type=style&index=0&id=0e0bcfcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0bcfcb",
  null
  
)

export default component.exports